class navHelper {
	constructor() {
	}

	init() {
	}

	mobileNav() {
        // mobile menu slide from the right
        $('[data-toggle="collapse"]').on('click', function(e) {
            const $navMenu = $($(this).data('target'));
            $navMenu.toggleClass('open');
            $(this).toggleClass('open');
            setTimeout(function() {
                $('body').toggleClass('noscroll');
            }, 1000);
            setTimeout(function() {
                $('html').toggleClass('noscroll');
            }, 1000);
        });
    }
}

window.app.add('nav', new navHelper());